module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "wrapper-md"
  }, [_c('div', {
    staticClass: "panel panel-default"
  }, [_c('div', {
    staticClass: "panel-body"
  }, [(_vm.cadastroError !== null) ? _c('div', {
    ref: "error",
    staticClass: "alert alert-danger",
    attrs: {
      "tabindex": "-1"
    }
  }, [_c('div', {
    staticClass: "m-b-sm font-bold"
  }, [_vm._v("Erro ao registrar o leilão, corrija e tente novamente")]), _vm._v(" "), _vm._l((_vm.cadastroError), function(erro, key) {
    return _c('p', [_vm._v(_vm._s(_vm.printError(erro)))])
  })], 2) : _vm._e(), _vm._v(" "), _c('a', {
    ref: "sucessMsg",
    attrs: {
      "name": "sucessMsg",
      "id": "sucessMsg",
      "href": "javascript:void(0)"
    }
  }), _vm._v(" "), (_vm.atualizadoSucesso !== null) ? _c('div', {
    ref: "error",
    staticClass: "alert alert-success",
    attrs: {
      "tabindex": "-1"
    }
  }, [_c('div', {
    staticClass: "font-bold"
  }, [_vm._v("Atualizado com sucesso!\n              "), _c('router-link', {
    staticClass: "btn btn-xs btn-success",
    attrs: {
      "to": {
        name: 'leiloes.visualizar',
        params: {
          id: _vm.$route.params.id
        }
      }
    }
  }, [_vm._v("\n                Voltar para o leilão\n              ")])], 1)]) : _vm._e(), _vm._v(" "), _c('form', {
    staticClass: "bs-example form-horizontal",
    on: {
      "submit": function($event) {
        $event.preventDefault();
        $event.stopPropagation();
      }
    }
  }, [_c('div', {
    staticClass: "clearfix"
  }, [_c('div', {
    staticClass: "col-lg-6 col-md-12"
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "line line-dashed b-b line-lg pull-in"
  }), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-lg-2 control-label"
  }, [_vm._v("Tipo")]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-10"
  }, [_c('u-button-group', {
    attrs: {
      "options": _vm.tiposLeilao
    },
    model: {
      value: (_vm.leilao.tipo),
      callback: function($$v) {
        _vm.$set(_vm.leilao, "tipo", $$v)
      },
      expression: "leilao.tipo"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-lg-2 control-label"
  }, [_vm._v("Judicial")]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-10"
  }, [_c('label', {
    staticClass: "i-switch bg-warning m-t-xs m-r"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.leilao.judicial),
      expression: "leilao.judicial"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.leilao.judicial) ? _vm._i(_vm.leilao.judicial, null) > -1 : (_vm.leilao.judicial)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.leilao.judicial,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.leilao, "judicial", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.leilao, "judicial", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.leilao, "judicial", $$c)
        }
      }
    }
  }), _vm._v(" "), _c('i')])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-lg-2 control-label"
  }, [_vm._v("Classificação")]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-10"
  }, [_c('select-categoria-leilao', {
    model: {
      value: (_vm.leilao.categoria),
      callback: function($$v) {
        _vm.$set(_vm.leilao, "categoria", $$v)
      },
      expression: "leilao.categoria"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-lg-2 control-label"
  }, [_vm._v("Sucata")]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-10"
  }, [_c('label', {
    staticClass: "i-switch bg-danger m-t-xs m-r"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.leilao.sucata),
      expression: "leilao.sucata"
    }],
    attrs: {
      "type": "checkbox",
      "disabled": this.$route.params.id
    },
    domProps: {
      "checked": Array.isArray(_vm.leilao.sucata) ? _vm._i(_vm.leilao.sucata, null) > -1 : (_vm.leilao.sucata)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.leilao.sucata,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.leilao, "sucata", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.leilao, "sucata", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.leilao, "sucata", $$c)
        }
      }
    }
  }), _vm._v(" "), _c('i')])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-lg-2 control-label"
  }, [_vm._v("Local")]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-10"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.leilao.local),
      expression: "leilao.local"
    }],
    staticClass: "form-control w-auto w-full-xs",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.leilao, "local", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "disabled": "",
      "value": ""
    }
  }, [_vm._v(_vm._s(_vm.loadTiposText))]), _vm._v(" "), _vm._l((_vm.locais), function(local) {
    return _c('option', {
      domProps: {
        "value": local.id
      }
    }, [_vm._v("\n                        " + _vm._s(local.nome) + "\n                      ")])
  })], 2), _vm._v(" "), (_vm.loadTiposError) ? _c('a', {
    staticClass: "btn text-danger",
    on: {
      "click": _vm.loadTipos
    }
  }, [_vm._v("Não foi possível carregar. Tente novamente")]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-lg-2 control-label"
  }, [_vm._v("Instância")]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-10"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.leilao.instancia),
      expression: "leilao.instancia"
    }],
    staticClass: "form-control w-auto w-full-xs",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.leilao, "instancia", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "disabled": "",
      "value": ""
    }
  }, [_vm._v("Selecione")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "1"
    }
  }, [_vm._v("Leilão Único")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "2"
    }
  }, [_vm._v("1º Leilão")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "3"
    }
  }, [_vm._v("2º Leilão")])])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-lg-2 control-label"
  }, [_vm._v("Data de Publicação")]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-10"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.dataPublicacao),
      expression: "dataPublicacao"
    }, {
      name: "mask",
      rawName: "v-mask",
      value: ('##/##/####'),
      expression: "'##/##/####'"
    }],
    staticClass: "form-control w-full-xs w-sm ",
    attrs: {
      "placeholder": "dd/mm/yyyy"
    },
    domProps: {
      "value": (_vm.dataPublicacao)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.dataPublicacao = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-lg-2 control-label"
  }, [_vm._v("Hora de Publicação")]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-10"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.horaPublicacao),
      expression: "horaPublicacao"
    }, {
      name: "mask",
      rawName: "v-mask",
      value: ('##:##'),
      expression: "'##:##'"
    }],
    staticClass: "form-control w-full-xs w-xs",
    attrs: {
      "placeholder": "00:00",
      "type": "time"
    },
    domProps: {
      "value": (_vm.horaPublicacao)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.horaPublicacao = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-lg-2 control-label"
  }, [_vm._v("Data de Abertura")]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-10"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.dataAbertura),
      expression: "dataAbertura"
    }, {
      name: "mask",
      rawName: "v-mask",
      value: ('##/##/####'),
      expression: "'##/##/####'"
    }],
    staticClass: "form-control w-full-xs w-sm ",
    attrs: {
      "placeholder": "dd/mm/yyyy"
    },
    domProps: {
      "value": (_vm.dataAbertura)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.dataAbertura = $event.target.value
      }
    }
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.leilao.semData),
      expression: "leilao.semData"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.leilao.semData) ? _vm._i(_vm.leilao.semData, null) > -1 : (_vm.leilao.semData)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.leilao.semData,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.leilao, "semData", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.leilao, "semData", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.leilao, "semData", $$c)
        }
      }
    }
  }), _vm._v(" Sem data\n                  ")])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-lg-2 control-label"
  }, [_vm._v("Hora de Abertura")]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-10"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.horaAbertura),
      expression: "horaAbertura"
    }, {
      name: "mask",
      rawName: "v-mask",
      value: ('##:##'),
      expression: "'##:##'"
    }],
    staticClass: "form-control w-full-xs w-xs",
    attrs: {
      "placeholder": "00:00",
      "type": "time"
    },
    domProps: {
      "value": (_vm.horaAbertura)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.horaAbertura = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-lg-2 control-label"
  }, [_vm._v("Automático")]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-10"
  }, [_c('div', {
    staticClass: "checkbox"
  }, [_c('label', {
    staticClass: "i-checks"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.leilao.automatico),
      expression: "leilao.automatico"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.leilao.automatico) ? _vm._i(_vm.leilao.automatico, null) > -1 : (_vm.leilao.automatico)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.leilao.automatico,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.leilao, "automatico", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.leilao, "automatico", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.leilao, "automatico", $$c)
        }
      }
    }
  }), _c('i')])])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-lg-2 control-label"
  }, [_vm._v("Loteado")]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-10"
  }, [_c('div', {
    staticClass: "checkbox"
  }, [_c('label', {
    staticClass: "i-checks"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.leilao.loteado),
      expression: "leilao.loteado"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.leilao.loteado) ? _vm._i(_vm.leilao.loteado, null) > -1 : (_vm.leilao.loteado)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.leilao.loteado,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.leilao, "loteado", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.leilao, "loteado", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.leilao, "loteado", $$c)
        }
      }
    }
  }), _c('i')])])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-lg-2 control-label"
  }, [_vm._v("Tempo do Pregão")]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-10"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.leilao.timerPregao),
      expression: "leilao.timerPregao"
    }, {
      name: "mask",
      rawName: "v-mask",
      value: ('########'),
      expression: "'########'"
    }],
    staticClass: "form-control inline m-r-xs w-xs",
    attrs: {
      "id": "timerPregao",
      "placeholder": "",
      "type": "number"
    },
    domProps: {
      "value": (_vm.leilao.timerPregao)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.leilao, "timerPregao", $event.target.value)
      }
    }
  }), _vm._v(" segundos\n                  ")])]), _vm._v(" "), _vm._m(2), _vm._v(" "), _c('div', {
    staticClass: "line line-dashed b-b line-lg pull-in"
  }), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-lg-2 control-label"
  }, [_vm._v("Leiloeiro")]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-10"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.leilao.leiloeiro),
      expression: "leilao.leiloeiro"
    }],
    staticClass: "form-control w-auto w-full-xs",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.leilao, "leiloeiro", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "disabled": "",
      "value": ""
    }
  }, [_vm._v(_vm._s(_vm.loadTiposText))]), _vm._v(" "), _vm._l((_vm.leiloeiros), function(leiloeiro) {
    return _c('option', {
      domProps: {
        "value": leiloeiro.id
      }
    }, [_vm._v("\n                        " + _vm._s(leiloeiro.nome) + "\n                      ")])
  })], 2), _vm._v(" "), (_vm.loadTiposError) ? _c('a', {
    staticClass: "btn text-danger",
    on: {
      "click": _vm.loadTipos
    }
  }, [_vm._v("Não foi possível carregar. Tente novamente")]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-lg-2 control-label"
  }, [_vm._v("Comissão")]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-10"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.leilao.valorComissao),
      expression: "leilao.valorComissao"
    }],
    staticClass: "form-control inline w-xxs",
    attrs: {
      "type": "number",
      "size": "5"
    },
    domProps: {
      "value": (_vm.leilao.valorComissao)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.leilao, "valorComissao", $event.target.value)
      }
    }
  }), _vm._v(" %\n                  ")])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "col-lg-10 col-lg-offset-2"
  }, [_c('div', {
    staticClass: "checkbox"
  }, [_c('label', {
    staticClass: "i-checks"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.leilao.cobraComissao),
      expression: "leilao.cobraComissao"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.leilao.cobraComissao) ? _vm._i(_vm.leilao.cobraComissao, null) > -1 : (_vm.leilao.cobraComissao)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.leilao.cobraComissao,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.leilao, "cobraComissao", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.leilao, "cobraComissao", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.leilao, "cobraComissao", $$c)
        }
      }
    }
  }), _c('i'), _vm._v(" Cobrar comissão\n                      ")])])])]), _vm._v(" "), _vm._m(3), _vm._v(" "), _c('div', {
    staticClass: "line line-dashed b-b line-lg pull-in"
  }), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "col-lg-10 col-lg-offset-2"
  }, [_c('div', {
    staticClass: "checkbox"
  }, [_c('label', {
    staticClass: "i-checks"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.leilao.cobraTaxasAdicionais),
      expression: "leilao.cobraTaxasAdicionais"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.leilao.cobraTaxasAdicionais) ? _vm._i(_vm.leilao.cobraTaxasAdicionais, null) > -1 : (_vm.leilao.cobraTaxasAdicionais)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.leilao.cobraTaxasAdicionais,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.leilao, "cobraTaxasAdicionais", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.leilao, "cobraTaxasAdicionais", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.leilao, "cobraTaxasAdicionais", $$c)
        }
      }
    }
  }), _c('i'), _vm._v(" Cobrar taxas\n                      ")])])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-lg-2 control-label"
  }, [_vm._v("Taxa ICMS")]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-10"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.leilao.valorTaxaIcms),
      expression: "leilao.valorTaxaIcms"
    }],
    staticClass: "form-control inline w-xs",
    attrs: {
      "type": "number",
      "size": "5"
    },
    domProps: {
      "value": (_vm.leilao.valorTaxaIcms)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.leilao, "valorTaxaIcms", $event.target.value)
      }
    }
  }), _vm._v(" %\n                  ")])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-lg-2 control-label"
  }, [_vm._v("Taxa ISS")]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-10"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.leilao.valorTaxaIss),
      expression: "leilao.valorTaxaIss"
    }],
    staticClass: "form-control inline w-xs",
    attrs: {
      "type": "number",
      "size": "5"
    },
    domProps: {
      "value": (_vm.leilao.valorTaxaIss)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.leilao, "valorTaxaIss", $event.target.value)
      }
    }
  }), _vm._v(" %\n                  ")])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-lg-2 control-label"
  }, [_vm._v("Taxa Boleto")]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-10"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.leilao.taxaBoleto),
      expression: "leilao.taxaBoleto"
    }, {
      name: "money",
      rawName: "v-money",
      value: (_vm.money),
      expression: "money"
    }],
    staticClass: "form-control inline w-xs",
    attrs: {
      "size": "5"
    },
    domProps: {
      "value": (_vm.leilao.taxaBoleto)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.leilao, "taxaBoleto", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-lg-2 control-label"
  }, [_vm._v("Porcentagem de Cobrança")]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-10"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.leilao.porcentagemCobranca),
      expression: "leilao.porcentagemCobranca"
    }],
    staticClass: "form-control w-auto w-full-xs",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.leilao, "porcentagemCobranca", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "disabled": "",
      "value": ""
    }
  }, [_vm._v("Selecione")]), _vm._v(" "), _vm._l((_vm.porcentagensCobranca), function(porcentagem) {
    return _c('option', {
      domProps: {
        "value": porcentagem.value
      }
    }, [_vm._v("\n                        " + _vm._s(porcentagem.label) + "\n                      ")])
  })], 2), _vm._v(" "), (_vm.loadTiposError) ? _c('a', {
    staticClass: "btn text-danger",
    on: {
      "click": _vm.loadTipos
    }
  }, [_vm._v("Não foi possível carregar. Tente novamente")]) : _vm._e()])]), _vm._v(" "), _vm._m(4), _vm._v(" "), _c('div', {
    staticClass: "line line-dashed b-b line-lg pull-in"
  }), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-lg-2 control-label"
  }, [_vm._v("ID Interno")]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-10"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.leilao.syncId),
      expression: "leilao.syncId"
    }],
    staticClass: "form-control w-sm w-full-xs",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.leilao.syncId)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.leilao, "syncId", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-lg-2 control-label"
  }, [_vm._v("Nº Leilão Interno")]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-10"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.leilao.syncExtra.codigoInterno),
      expression: "leilao.syncExtra.codigoInterno"
    }],
    staticClass: "form-control w-sm w-full-xs",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.leilao.syncExtra.codigoInterno)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.leilao.syncExtra, "codigoInterno", $event.target.value)
      }
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-6 col-md-12"
  }, [_vm._m(5), _vm._v(" "), _c('div', {
    staticClass: "line line-dashed b-b line-lg pull-in"
  }), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-lg-2 control-label"
  }, [_vm._v("Título")]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-10"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.leilao.titulo),
      expression: "leilao.titulo"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.leilao.titulo)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.leilao, "titulo", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-lg-2 control-label"
  }, [_vm._v("Descrição")]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-10"
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.leilao.descricao),
      expression: "leilao.descricao"
    }],
    staticClass: "form-control",
    staticStyle: {
      "resize": "none"
    },
    attrs: {
      "rows": "5"
    },
    domProps: {
      "value": (_vm.leilao.descricao)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.leilao, "descricao", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-lg-2 control-label"
  }, [_vm._v("Informação de Visitação")]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-10"
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.leilao.infoVisitacao),
      expression: "leilao.infoVisitacao"
    }],
    staticClass: "form-control",
    staticStyle: {
      "resize": "none"
    },
    attrs: {
      "rows": "5"
    },
    domProps: {
      "value": (_vm.leilao.infoVisitacao)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.leilao, "infoVisitacao", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-lg-2 control-label"
  }, [_vm._v("Informação de Retirada")]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-10"
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.leilao.infoRetirada),
      expression: "leilao.infoRetirada"
    }],
    staticClass: "form-control",
    staticStyle: {
      "resize": "none"
    },
    attrs: {
      "rows": "5"
    },
    domProps: {
      "value": (_vm.leilao.infoRetirada)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.leilao, "infoRetirada", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-lg-2 control-label"
  }, [_vm._v("Observações")]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-10"
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.leilao.observacao),
      expression: "leilao.observacao"
    }],
    staticClass: "form-control",
    staticStyle: {
      "resize": "none"
    },
    attrs: {
      "rows": "5"
    },
    domProps: {
      "value": (_vm.leilao.observacao)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.leilao, "observacao", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-lg-2 control-label"
  }, [_vm._v("Imagem Destaque")]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-10"
  }, [_c('input', {
    attrs: {
      "type": "file",
      "id": "fotoDestaque"
    },
    on: {
      "change": _vm.geraPreview
    }
  }), _vm._v(" "), (_vm.leilao.fotoDestaque || _vm.imagemLeilaoTmp) ? _c('div', [_c('img', {
    staticStyle: {
      "max-width": "100%"
    },
    attrs: {
      "src": _vm.leilao.fotoDestaque || _vm.imagemLeilaoTmp
    }
  })]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-lg-2 control-label"
  }, [_vm._v("Habilitar Imagem Destaque")]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-10"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.leilao.habilitarFotoDestaque),
      expression: "leilao.habilitarFotoDestaque"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.leilao.habilitarFotoDestaque) ? _vm._i(_vm.leilao.habilitarFotoDestaque, null) > -1 : (_vm.leilao.habilitarFotoDestaque)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.leilao.habilitarFotoDestaque,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.leilao, "habilitarFotoDestaque", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.leilao, "habilitarFotoDestaque", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.leilao, "habilitarFotoDestaque", $$c)
        }
      }
    }
  })])]), _vm._v(" "), _vm._m(6), _vm._v(" "), _c('div', {
    staticClass: "line line-dashed b-b line-lg pull-in"
  }), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-lg-2 control-label"
  }, [_vm._v("Data Inicial")]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-10"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.leilao.dataAgendamentoInicial),
      expression: "leilao.dataAgendamentoInicial"
    }, {
      name: "mask",
      rawName: "v-mask",
      value: ('##/##/####'),
      expression: "'##/##/####'"
    }],
    staticClass: "form-control w-full-xs w-sm ",
    attrs: {
      "placeholder": "dd/mm/yyyy"
    },
    domProps: {
      "value": (_vm.leilao.dataAgendamentoInicial)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.leilao, "dataAgendamentoInicial", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-lg-2 control-label"
  }, [_vm._v("Data Final")]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-10"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.leilao.dataAgendamentoFinal),
      expression: "leilao.dataAgendamentoFinal"
    }, {
      name: "mask",
      rawName: "v-mask",
      value: ('##/##/####'),
      expression: "'##/##/####'"
    }],
    staticClass: "form-control w-full-xs w-sm ",
    attrs: {
      "placeholder": "dd/mm/yyyy"
    },
    domProps: {
      "value": (_vm.leilao.dataAgendamentoFinal)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.leilao, "dataAgendamentoFinal", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _vm._m(7), _vm._v(" "), _c('div', {
    staticClass: "line line-dashed b-b line-lg pull-in"
  }), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-lg-2 control-label"
  }, [_vm._v("Data Inicial")]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-10"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.leilao.dataRetiradaInicial),
      expression: "leilao.dataRetiradaInicial"
    }, {
      name: "mask",
      rawName: "v-mask",
      value: ('##/##/####'),
      expression: "'##/##/####'"
    }],
    staticClass: "form-control w-full-xs w-sm ",
    attrs: {
      "placeholder": "dd/mm/yyyy"
    },
    domProps: {
      "value": (_vm.leilao.dataRetiradaInicial)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.leilao, "dataRetiradaInicial", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-lg-2 control-label"
  }, [_vm._v("Data Final")]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-10"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.leilao.dataRetiradaFinal),
      expression: "leilao.dataRetiradaFinal"
    }, {
      name: "mask",
      rawName: "v-mask",
      value: ('##/##/####'),
      expression: "'##/##/####'"
    }],
    staticClass: "form-control w-full-xs w-sm ",
    attrs: {
      "placeholder": "dd/mm/yyyy"
    },
    domProps: {
      "value": (_vm.leilao.dataRetiradaFinal)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.leilao, "dataRetiradaFinal", $event.target.value)
      }
    }
  })])])])]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('div', {
    staticClass: "row wrapper"
  }, [_c('u-button', {
    staticClass: "btn m-b-xs w-xs btn-info m-r-xs",
    on: {
      "click": _vm.submit
    }
  }, [(!_vm.leilao.id) ? _c('span', [_vm._v("Cadastrar")]) : _vm._e(), _vm._v(" "), (_vm.leilao.id) ? _c('span', [_vm._v("Atualizar")]) : _vm._e()]), _vm._v(" "), _c('u-button', {
    staticClass: "btn m-b-xs w-xs m-r-xs btn-default"
  }, [_vm._v("Cancelar")]), _vm._v(" "), (!_vm.leilao.id) ? _c('span', [_vm._v("Ao cadastrar, o status do leilão será "), _c('span', {
    staticClass: "text-info"
  }, [_vm._v("Rascunho")]), _vm._v(", para publicá-lo, altere o status após o cadastro.")]) : _vm._e()], 1)])])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "bg-light lter b-b wrapper-md"
  }, [_c('h1', {
    staticClass: "m-n font-thin h3"
  }, [_vm._v("Cadastro de Leilão")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "col-lg-offset-2 col-lg-10"
  }, [_c('span', {
    staticClass: "help-block m-b-none"
  }, [_vm._v("Configure o leilão")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "col-lg-offset-2 col-lg-10"
  }, [_c('span', {
    staticClass: "help-block m-b-none"
  }, [_vm._v("Leiloeiro")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "form-group m-t-lg"
  }, [_c('div', {
    staticClass: "col-lg-offset-2 col-lg-10"
  }, [_c('span', {
    staticClass: "help-block m-b-none"
  }, [_vm._v("Financeiro")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "form-group m-t-lg"
  }, [_c('div', {
    staticClass: "col-lg-offset-2 col-lg-10"
  }, [_c('span', {
    staticClass: "help-block m-b-none"
  }, [_vm._v("Sistemas integrados")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "col-lg-offset-2 col-lg-10"
  }, [_c('span', {
    staticClass: "help-block m-b-none"
  }, [_vm._v("Informações sobre o leilão")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "col-lg-offset-2 col-lg-10"
  }, [_c('span', {
    staticClass: "help-block m-b-none"
  }, [_vm._v("Prazo para Agendamento")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "col-lg-offset-2 col-lg-10"
  }, [_c('span', {
    staticClass: "help-block m-b-none"
  }, [_vm._v("Prazo para Retirada")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-071a5180","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/app/website/leiloes/components/NovoLeilao.vue
// module id = 1467
// module chunks = 17